<div class="row" style="margin-top:10px">
    <div class="col-3">
        <mat-form-field appearance="fill" class="gray-text" style="width:100%">    
            <mat-label>Select Amano One PARCS Access Group*</mat-label>
            <mat-select matNativeControl [ngModel]="accessGroupId" (ngModelChange)="onAccessGroupChange($event)" [disabled]="!createAmanoOneProfile">
                @if(amanoOneAccessGroups.length === 0) {
                    <mat-option value="">Loading Access Groups...</mat-option>
                }
                @else {
                    <mat-option value="">Select Access Group</mat-option>
                    <mat-option *ngFor="let group of amanoOneAccessGroups" [value]="group.accessGroupID" >
                    {{group.name}} 
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <span style="font-weight:normal;font-size:14px;position:relative;top:-15px;left:10px;">By default Parker status = neutral, mode=normal</span>   
    </div>
    @if(parkerCardNumber != ''){
    <div class="col-3">
       <div style="display:flex; align-items:center;">
           <mat-form-field appearance="fill" style="width:98%;color:gray;margin-left:10px;">
                <mat-label>Select Credential Type ({{credentialTypesList.length}})*</mat-label>
                <mat-select [(ngModel)]="credentialTypeId" (ngModelChange)="onCredentialTypeChange($event)" [disabled]="!createAmanoOneProfile">
                    @if(credentialTypesList.length === 0) {
                        @if(credentialTypesLoadFailed) {
                            <mat-option value="">Unable to contact Amano One.  Try again</mat-option>
                        }
                        @else {
                            <mat-option value="">Loading Credential Types...</mat-option>
                        }
                    }
                    @else {
                        <mat-option value="">Select Credential Type</mat-option>
                        <mat-option *ngFor="let type of credentialTypesList" [value]="type.credentialTypeId" >
                        {{type.credentialTypeName}} 
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="refresh" matTooltip="Reload Credential Types" style="margin-left:5px; position:relative; top:-4px; cursor:pointer;" (click)="reloadCredentialTypes()"></mat-icon>
       </div>
    </div>
     <div class="col-3">
        @if(credentialTypeId == ''){
            <div style="margin-top:20px;">
                    <span>&larr; Select Credential Type</span>
            </div>
        }
        @else{
            @if(credentialTypeNoSystemCodeFlag){
                <div style="margin-top:20px;">
                    <span>No Credential System Code required for this Credential Type</span>
                </div>
            }
            @else {
                <mat-form-field appearance="fill" style="width:98%;color:gray;">
                <mat-label>Select Credential Code  ({{credentialCodesList.length}})*</mat-label>
                        <mat-select (selectionChange)="onCredentialCodeChange($event)" [(ngModel)]="credentialCodeSettingValue" [disabled]="!createAmanoOneProfile">
                            <mat-option value="">Select Credential Code</mat-option>
                            <mat-option *ngFor="let code of credentialCodesList" [value]="code.credentialCode">
                            {{code.credentialCode}} 
                            </mat-option>
                        </mat-select>
                </mat-form-field>
            }
        }
    </div>
    }
    @else {
        <div class="col-6">
            <div style="margin-top:20px;">
                <span>No Card Number for this Parker.  Enter card number above to select Credential Type and Code</span>
            </div>
        </div>
    }
     <div class="col-2">
        <div style="margin-top:10px;">
            <mat-checkbox 
                matTooltip="Unchecking this will result in the Parker profile not being created in Amano One system."
                [(ngModel)]="createAmanoOneProfile" (change)="onSaveAmanoProfileChange()" 
                style="font-size:14px;color:gray" class="gray-text">
                    <span  style="font-weight:normal;" class="gray-text">Create Profile to Amano One</span>
            </mat-checkbox>
         </div>
    </div>
    </div>




